import React from 'react';
import Container from '@amzn/awsui-components-console/container';
import Link from '@amzn/awsui-components-console/link';
import { formatEpochMillisDate } from 'src/features/namespace/utils';
import styles from './NamespaceMetadataCard.module.scss';
import ContentLayout from '@amzn/awsui-components-console/content-layout';

export interface NamespaceMetadataCardProps {
  readonly cxFamily?: string | null;
  readonly bindleLabel?: string | null;
  readonly bindleHref?: string;
  readonly ownerHref?: string;
  readonly createdAt?: number | null;
  readonly createdBy?: string | null;
}

/**
 * Stacked metadata card displaying namespace metadata in a bordered container
 * with divider-separated label/value rows using semantic description-list markup.
 */
const NamespaceMetadataCard: React.FC<NamespaceMetadataCardProps> = ({
  cxFamily,
  bindleLabel,
  bindleHref,
  ownerHref,
  createdAt,
  createdBy,
}) => {
  const formatDateWithAuthor = (
    epochMillis?: number | null,
    author?: string | null,
  ): string => {
    const date = formatEpochMillisDate(epochMillis);
    if (author) return `${date} by ${author}`;
    return date;
  };

  return (
    <ContentLayout maxContentWidth={390}>
      <Container>
        <dl className={styles.list}>
          {cxFamily?.trim() && (
            <div className={styles.row}>
              <dt className={styles.label}>CX Family</dt>
              <dd className={styles.value}>{cxFamily}</dd>
            </div>
          )}
          <div className={styles.row}>
            <dt className={styles.label}>Linked Bindle</dt>
            <dd className={styles.value}>
              <Link external href={bindleHref} />
            </dd>
          </div>
          <div className={styles.row}>
            <dt className={styles.label}>Created At</dt>
            <dd className={styles.value}>
              {formatDateWithAuthor(createdAt, createdBy)}
            </dd>
          </div>
          <div className={styles.row}>
            <dt className={styles.label}>Owner</dt>
            <dd className={styles.value}>
              <Link external href={ownerHref} />
            </dd>
          </div>
        </dl>
      </Container>
    </ContentLayout>
  );
};

export default NamespaceMetadataCard;
